var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5072 216.259H149.216C149.827 216.259 150.323 216.755 150.323 217.366V224.694H56.4V217.366C56.4 216.755 56.8957 216.259 57.5072 216.259Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 224.694H150.323V316.614C150.323 317.721 149.426 318.618 148.32 318.618H58.4C57.2937 318.618 56.3968 317.721 56.3968 316.614V224.694H56.4Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8176 224.694V318.621",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 238.112H150.323",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2352 224.694V318.621",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6528 224.694V318.621",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07 224.694V318.621",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.488 224.694V318.621",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.906 224.694L137.315 318.621",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 251.53H150.323",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 264.947H150.323",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 278.368H150.323",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 291.786H150.323",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 305.203H150.323",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.411 218.23L146.058 222.397",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.058 218.23L141.411 222.397",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.906 216.259V224.368",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4 256.429C75.6992 257.805 78.3136 260.611 78.3136 260.611L74.4 256.429Z",
    fill: "#FF5986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4 256.429C75.6992 257.805 78.3136 260.611 78.3136 260.611",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9344 256.848C77.408 257.344 78.1824 258.166 78.7232 258.746L76.9344 256.848Z",
    fill: "#FF5986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9344 256.848C77.408 257.344 78.1824 258.166 78.7232 258.746",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7552 258.899C74.9248 259.069 75.2736 259.43 76.0352 260.256L74.7552 258.899Z",
    fill: "#FF5986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7552 258.899C74.9248 259.069 75.2736 259.43 76.0352 260.256",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5072 220.314H87.6256",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.112 102.24H249.648V199.704H347.112V102.24Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.676 199.7L347.112 104.268",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.648 183.716L331.128 102.24",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.124 134.308L347.112 120.32",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.732 199.7L328.1 139.332",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.156 199.7L347.112 138.744",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.208 199.7L347.112 154.796",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.648 167.052L314.46 102.24",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.648 149.036L296.448 102.24",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.808 199.7L347.112 172.396",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.86 199.7L347.112 188.452",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.648 132.296L279.708 102.24",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.648 114.284L261.696 102.24",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.32 62.7123H210.7V139.332H287.32V62.7123Z",
    fill: "#6DE4A2",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 62.7123L287.32 139.332",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7 139.332L287.32 62.7123",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.405 132.52H83.1517V291.957H310.405V132.52Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.405 121.26H83.1517V132.52H310.405V121.26Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3558 123.888H88.5868V129.892H94.3558V123.888Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8826 128.428H93.0574",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.385 123.888H100.616V129.892H106.385V123.888Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.947 125.384H102.056V128.393H104.947V125.384Z",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.414 123.888H112.645V129.892H118.414V123.888Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.085 125.384L116.976 128.395",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.085 128.395L116.976 125.384",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.347 291.957H83.1517L109.958 263.066L119.642 265.452L135.643 248.545L143.849 255.911L152.472 248.545L154.214 235.522L169.644 215.209L178.344 222.265L182.022 220.5L185.356 224.029L186.438 227.055L189.627 231.843L199.404 248.545L222.018 262.851L233.429 261.765L248.309 285.387L258.347 291.957Z",
    fill: "#7774FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.643 248.545L143.376 291.957L119.642 265.452L129.757 291.957L143.849 255.911L199.404 248.545L94.0343 291.957L109.958 263.066L115.408 291.957",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.309 285.387L219.372 291.957L222.018 262.851L248.309 285.387Z",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.344 222.265L154.214 235.522L209.97 291.957L233.429 261.765L238.899 291.957",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.018 262.851L143.376 291.957",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.642 265.452C121.668 265.529 143.849 255.911 143.849 255.911",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.022 220.5L201.781 291.957L199.404 248.545L178.344 291.957",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.405 250.102V291.957H257.836L268.706 278.344L275.788 278.834L281.161 282.146L286.412 275.155L296.768 271.028L300.778 261.795L310.405 250.102Z",
    fill: "#7774FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.412 275.155L293.143 291.957L310.405 250.102",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.706 278.344L275.773 291.957L281.161 282.146L258.347 291.957",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.778 261.795L310.405 291.957L296.768 271.028",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.405 291.957L281.161 282.146",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.345 180.487C218.987 180.487 221.939 177.522 221.939 173.865C221.939 170.207 218.987 167.242 215.345 167.242C211.703 167.242 208.751 170.207 208.751 173.865C208.751 177.522 211.703 180.487 215.345 180.487Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.063 198.112C190.784 198.112 190.786 196.986 190.063 196.986C189.341 196.986 189.341 198.112 190.063 198.112Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.376 178.137C144.338 178.137 144.34 176.635 143.376 176.635C142.411 176.635 142.411 178.137 143.376 178.137Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.782 208.249C296.744 208.249 296.744 206.747 295.782 206.747C294.82 206.747 294.817 208.249 295.782 208.249Z",
    fill: "#9AF3FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.39 155.188C107.112 155.188 107.112 154.062 106.39 154.062C105.667 154.062 105.667 155.188 106.39 155.188Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.957 150.057C175.677 150.057 175.68 148.931 174.957 148.931C174.234 148.931 174.234 150.057 174.957 150.057Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.627 226.72C205.349 226.72 205.349 225.594 204.627 225.594C203.904 225.594 203.904 226.72 204.627 226.72Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.309 147.274C249.029 147.274 249.032 146.148 248.309 146.148C247.586 146.148 247.586 147.274 248.309 147.274Z",
    fill: "#6DE4A2",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.778 157.941C297.501 157.941 297.501 156.815 296.778 156.815C296.056 156.815 296.056 157.941 296.778 157.941Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.376 215.772C144.096 215.772 144.099 214.646 143.376 214.646C142.653 214.646 142.653 215.772 143.376 215.772Z",
    fill: "#FFFEAA",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.056 249.108C102.776 249.108 102.779 247.982 102.056 247.982C101.333 247.982 101.333 249.108 102.056 249.108Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.056 202.723C102.776 202.723 102.779 201.596 102.056 201.596C101.333 201.596 101.333 202.723 102.056 202.723Z",
    fill: "#C0FF97",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.161 250.665C281.884 250.665 281.884 249.538 281.161 249.538C280.438 249.538 280.438 250.665 281.161 250.665Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.309 244.878C249.271 244.878 249.271 243.376 248.309 243.376C247.347 243.376 247.345 244.878 248.309 244.878Z",
    fill: "#FFB8D2",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.612 223.429C268.366 223.429 277.894 213.859 277.894 202.054C277.894 190.249 268.366 180.68 256.612 180.68C244.859 180.68 235.331 190.249 235.331 202.054C235.331 213.859 244.859 223.429 256.612 223.429Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.207 186.181C264.174 186.89 266.01 187.923 267.639 189.237",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.497 198.508C256.508 200.645 260.55 205.003 260.55 205.003",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.402 199.161C259.134 199.934 260.33 201.208 261.17 202.107",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.035 202.36C255.284 202.622 255.84 203.186 257.029 204.467",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.843 310.937H204.186V323.596H216.843V310.937Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.173 299.931V343.126H228.369V299.931H185.173ZM216.843 331.899H195.881V310.937H216.843V331.899Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.186 310.934V323.594L195.881 331.899V310.934H204.186Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.843 323.594V331.899H195.881L204.186 323.594H216.843Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.173 299.929L206.771 278.747H248.514L228.369 299.929H185.173Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.369 343.124V299.929L248.514 278.747V321.526L228.369 343.124Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.843 310.937H204.186V323.596H216.843V310.937Z",
    fill: "#1062b9",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.425 310.937V326.254H216.789",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.72 310.934V328.993H216.843",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.843 278.937H256.186V291.596H268.843V278.937Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.173 267.931V311.126H280.369V267.931H237.173ZM268.843 299.899H247.881V278.937H268.843V299.899Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.186 278.934V291.594L247.881 299.899V278.934H256.186Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.843 291.594V299.899H247.881L256.186 291.594H268.843Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.173 267.929L258.771 246.747H300.514L280.369 267.929H237.173Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.369 311.124V267.929L300.514 246.747V289.526L280.369 311.124Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.843 278.937H256.186V291.596H268.843V278.937Z",
    fill: "#1062b9",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.425 278.937V294.254H268.789",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.72 278.934V296.993H268.843",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.843 246.937H308.186V259.596H320.843V246.937Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.173 235.931V279.126H332.369V235.931H289.173ZM320.843 267.899H299.881V246.937H320.843V267.899Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.186 246.934V259.594L299.88 267.899V246.934H308.186Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.843 259.594V267.899H299.88L308.186 259.594H320.843Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.173 235.929L310.771 214.747H352.514L332.369 235.929H289.173Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.369 279.124V235.929L352.514 214.747V257.526L332.369 279.124Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.843 246.937H308.186V259.596H320.843V246.937Z",
    fill: "#1062b9",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.425 246.937V262.254H320.789",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72 246.934V264.993H320.843",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.815 78.8524V181.193C149.815 181.633 149.459 181.99 149.019 181.992H64.358C63.918 181.99 63.5624 181.633 63.5624 181.193V78.8524C63.5605 78.6786 63.6277 78.5112 63.7492 78.387C63.8707 78.2628 64.0366 78.1919 64.2104 78.19H149.17C149.344 78.1919 149.509 78.2629 149.63 78.3872C149.751 78.5115 149.818 78.679 149.815 78.8524Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.082 89.8288V183.458C147.083 183.669 147 183.873 146.851 184.023C146.701 184.172 146.498 184.257 146.287 184.257H61.64C61.4284 184.257 61.2255 184.172 61.0762 184.023C60.9269 183.873 60.8435 183.669 60.8444 183.458V89.8288H147.082Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9112 102.18H73.6136C72.8979 102.18 72.3176 102.761 72.3176 103.476V115.774C72.3176 116.49 72.8979 117.07 73.6136 117.07H85.9112C86.627 117.07 87.2072 116.49 87.2072 115.774V103.476C87.2072 102.761 86.627 102.18 85.9112 102.18Z",
    fill: "#47DDDF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8996 108.286L79.2368 113.326C79.2571 113.363 79.2957 113.385 79.3376 113.385C79.3795 113.385 79.4181 113.363 79.4384 113.326L83.6288 105.863",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4712 126.909H73.0536C72.6471 126.909 72.3176 127.238 72.3176 127.645V141.062C72.3176 141.469 72.6471 141.798 73.0536 141.798H86.4712C86.8777 141.798 87.2072 141.469 87.2072 141.062V127.645C87.2072 127.238 86.8777 126.909 86.4712 126.909Z",
    fill: "#47DDDF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8996 133L79.2368 138.04C79.2571 138.077 79.2957 138.099 79.3376 138.099C79.3795 138.099 79.4181 138.077 79.4384 138.04L83.6288 130.577",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5192 151.641H73.0056C72.6257 151.641 72.3176 151.949 72.3176 152.329V165.842C72.3176 166.222 72.6257 166.53 73.0056 166.53H86.5192C86.8992 166.53 87.2072 166.222 87.2072 165.842V152.329C87.2072 151.949 86.8992 151.641 86.5192 151.641Z",
    fill: "#47DDDF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9968 157.746L79.3304 162.786C79.3521 162.821 79.3902 162.842 79.4312 162.842C79.4722 162.842 79.5103 162.821 79.532 162.786L83.726 155.32",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.329 80.44H146.449C146.623 80.4409 146.789 80.5115 146.911 80.6359C147.033 80.7604 147.1 80.9283 147.097 81.1024V89.8144H60.8297V81.1168C60.8242 80.9406 60.8897 80.7694 61.0116 80.642C61.1336 80.5147 61.3017 80.4418 61.478 80.44H126.181",
    fill: "#9E59FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.329 80.44H146.449C146.623 80.4409 146.789 80.5115 146.911 80.6359C147.033 80.7604 147.1 80.9283 147.097 81.1024V89.8144H60.8297V81.1168C60.8242 80.9406 60.8897 80.7694 61.0116 80.642C61.1336 80.5147 61.3017 80.4418 61.478 80.44H126.181",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1288 85.1416H92.726",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4816 85.1416H85.922",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5852 106.77H127.102",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.376 112.476H135.372",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5852 112.476H110.434",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.811 131.502H135.372",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5852 131.502H119.013",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5852 137.208H135.372",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.102 156.234H135.372",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5852 156.234H124.896",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5852 161.94H128.326",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.164 171.808L134.342 175.721",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.788 169.241L137.485 175.883",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.362 170.177L138.583 172.366",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.614 214.64C150.211 209.467 150.379 203.382 150.379 203.382C137.502 219.951 127.968 223.616 126.417 224.13C126.36 224.15 126.297 224.143 126.245 224.113C126.192 224.083 126.156 224.032 126.144 223.973C123.772 213.119 135.464 190.649 135.464 190.649C131.873 193.597 126.629 196.443 124.811 197.42C124.676 197.488 124.515 197.478 124.39 197.393C124.265 197.308 124.196 197.162 124.21 197.013C126.557 172.309 142.746 160.947 146.733 158.503C147.939 159.522 149.277 160.556 150.727 161.608C147.925 164.521 140.89 172.549 139.359 181.298C139.359 181.298 143.583 179.353 146.923 178.953C146.923 178.953 142.349 190.227 142.412 196.963C142.412 196.963 151.728 189.459 155.681 185.298C155.196 187.694 155.088 190.151 155.359 192.583C155.359 192.583 163.934 187.847 169.279 172.246C170.968 172.999 172.593 173.642 174.12 174.174C170.732 197.726 155.324 212.231 152.333 214.854C152.225 214.969 152.06 215.013 151.908 214.968C151.756 214.922 151.642 214.796 151.614 214.64Z",
    fill: "#1062b9",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.323 192.576C155.053 190.137 155.166 187.672 155.657 185.27C151.703 189.432 142.388 196.935 142.388 196.935C142.331 190.19 146.899 178.925 146.899 178.925C143.564 179.316 139.334 181.27 139.334 181.27C140.875 172.527 147.911 164.5 150.702 161.58C153.541 163.619 156.481 165.511 159.512 167.251C162.666 169.076 165.917 170.729 169.251 172.202C163.897 187.84 155.323 192.576 155.323 192.576Z",
    fill: "#1062b9",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.603 211.082C140.226 209.485 141.733 207.776 143.114 205.967",
    stroke: "#0D052C",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.47 213.67C136.108 213.261 136.712 212.801 137.275 212.296",
    stroke: "#0D052C",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.81 167.988L186.049 174.503C184.793 176.678 180.226 176.33 174.099 174.176C172.572 173.643 170.936 173.021 169.258 172.247C165.925 170.774 162.674 169.121 159.52 167.296C156.486 165.549 153.544 163.648 150.703 161.601C149.279 160.564 147.916 159.515 146.71 158.497C141.469 154.095 138.708 150.165 140.007 147.914L143.806 141.334C150.476 147.39 157.759 152.735 165.537 157.284C173.24 161.675 181.374 165.262 189.81 167.988Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.311 155.19C209.386 159.649 206.738 163.383 204.748 166.128C202.576 169.102 198.803 170.453 195.219 169.54C193.676 169.153 191.87 168.648 189.838 167.998C181.389 165.273 173.244 161.679 165.535 157.276C157.753 152.733 150.469 147.387 143.804 141.326C142.35 139.99 141.106 138.769 140.066 137.698C137.482 135.052 136.767 131.108 138.261 127.742C139.621 124.674 141.558 120.489 143.958 115.726C149.535 104.641 157.687 90.4514 167.212 79.8403C168.358 78.5685 169.51 77.3545 170.671 76.1852C177.537 69.39 185.401 63.6774 193.994 59.2423C200.363 64.2008 207.074 68.7038 214.078 72.7174C221.3 76.9269 228.824 80.5975 236.586 83.6989C237.024 93.0632 236.038 102.434 233.662 111.493C233.162 113.433 232.561 115.408 231.884 117.4C227.314 130.792 219.081 144.854 212.311 155.19Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.212 79.8403C157.707 90.4631 149.531 104.625 143.949 115.707L132.721 109.225C131.902 108.754 131.314 107.968 131.094 107.052C130.875 106.136 131.044 105.171 131.562 104.387C146.03 82.6676 167.212 79.8403 167.212 79.8403Z",
    fill: "#FF5986",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.886 66.2178C235.416 71.9349 236.327 77.7966 236.604 83.7026C228.842 80.6012 221.318 76.9306 214.096 72.7212C207.092 68.7075 200.381 64.2045 194.012 59.2461C207.016 52.5836 218.261 50.8129 223.751 50.3443C225.968 50.1542 228.081 51.3392 229.074 53.3302C230.497 56.2083 231.708 59.1848 232.699 62.2362",
    fill: "#9E59FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.886 66.2178C235.416 71.9349 236.327 77.7966 236.604 83.7026C228.842 80.6012 221.318 76.9306 214.096 72.7212C207.092 68.7075 200.381 64.2045 194.012 59.2461C207.016 52.5836 218.261 50.8129 223.751 50.3443C225.968 50.1542 228.081 51.3392 229.074 53.3302C230.497 56.2083 231.708 59.1848 232.699 62.2362",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.547 63.3768C229.546 65.9066 230.382 68.4967 231.05 71.1315",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.311 155.19C219.101 144.866 227.335 130.803 231.907 117.407L232.027 117.268C232.027 117.268 240.19 137.071 228.547 160.509C228.134 161.32 227.405 161.924 226.53 162.181C225.655 162.437 224.711 162.323 223.92 161.865L212.311 155.19Z",
    fill: "#FF5986",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.333 145.577C228.198 146.291 228.032 147.021 227.848 147.761",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.948 136.582C229.063 138.777 228.984 140.978 228.712 143.158",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.282 173.313C159.924 175.416 167.682 168.799 173.608 158.534C179.535 148.268 181.387 138.242 177.745 136.139C174.102 134.036 166.345 140.653 160.418 150.918C154.491 161.184 152.639 171.211 156.282 173.313Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.789 139.85C176.793 142.032 176.423 144.198 175.695 146.253",
    stroke: "#0D052C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.955 123.896C194.091 129.171 205.755 126.074 211.006 116.979C216.257 107.884 213.107 96.2352 203.97 90.9601C194.834 85.6851 183.17 88.7817 177.919 97.8767C172.668 106.972 175.818 118.621 184.955 123.896Z",
    fill: "#1062b9",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.139 103.482L190.034 110.953",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.635 101.137L194.457 113.815",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.035 105.477L198.98 109.66",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.018 101.064C217.388 102.461 217.627 103.889 217.732 105.329",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.374 89.925C212.754 92.1475 214.645 94.8397 215.926 97.8291",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.273 117.172C171.226 112.991 170.466 108.302 171.09 103.701",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming_soon.b7c9ec523a84a954332d1c6185aa38ee.svg";
export { ForwardRef as ReactComponent };